"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Errors = exports.Message = void 0;
var Message;
(function (Message) {
    Message["INIT"] = "one:init";
    Message["UPDATE"] = "one:update";
    Message["METHOD_CALL"] = "one:method:call";
    Message["METHOD_CALL_ERROR"] = "one:method:error";
    Message["METHOD_RESULT"] = "one:method:result";
    Message["NAVIGATION_PUSH"] = "one:navigation:push";
    Message["FRAME_HEIGHT_REQUEST"] = "one:frameheight:request";
    Message["FRAME_HEIGHT_CHANGE"] = "one:frameheight:change";
})(Message = exports.Message || (exports.Message = {}));
var Errors;
(function (Errors) {
    Errors["METHOD_DOES_NOT_EXISTS"] = "Method does not exists";
    Errors["SERVICE_DOES_NOT_EXISTS"] = "Service does not exists";
})(Errors = exports.Errors || (exports.Errors = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWVzc2FnZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvc2hhcmVkL21lc3NhZ2VzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLElBQVksT0FTWDtBQVRELFdBQVksT0FBTztJQUNqQiw0QkFBZSxDQUFBO0lBQ2YsZ0NBQW1CLENBQUE7SUFDbkIsMENBQTZCLENBQUE7SUFDN0IsaURBQW9DLENBQUE7SUFDcEMsOENBQWlDLENBQUE7SUFDakMsa0RBQXFDLENBQUE7SUFDckMsMkRBQThDLENBQUE7SUFDOUMseURBQTRDLENBQUE7QUFDOUMsQ0FBQyxFQVRXLE9BQU8sR0FBUCxlQUFPLEtBQVAsZUFBTyxRQVNsQjtBQUVELElBQVksTUFHWDtBQUhELFdBQVksTUFBTTtJQUNoQiwyREFBaUQsQ0FBQTtJQUNqRCw2REFBbUQsQ0FBQTtBQUNyRCxDQUFDLEVBSFcsTUFBTSxHQUFOLGNBQU0sS0FBTixjQUFNLFFBR2pCIn0=